/* Kanpla: make the theme's recommendation blocks actually load.

   product-recommendations fetches its products from two triggers set up in
   connectedCallback: an IntersectionObserver, and a MutationObserver watching
   its own attributes. On these product pages the IntersectionObserver never
   fires, so the block sits on its skeleton forever, which is why the add-ons
   panel and the recommendations row render as tall empty bands.

   The likely reason is that the element has no laid-out box at the moment the
   observer attaches, and a zero-area target never reports as intersecting, so
   the one-shot callback returns without ever disconnecting or retrying.

   Rather than fight the observer, this nudges the attribute the component is
   already watching. That runs its own supported code path: the MutationObserver
   fires, #loadRecommendations runs, and its internal
   data-recommendations-performed guard still prevents a double fetch. Only
   blocks that have not already loaded are touched.

   Runs at DOMContentLoaded and again at load, because the second pass catches
   blocks whose markup arrives late, and on shopify:section:load so the theme
   editor behaves too. */
(function () {
  function nudge() {
    var pending = document.querySelectorAll(
      'product-recommendations[data-recommendations-performed="false"]'
    );

    Array.prototype.forEach.call(pending, function (element) {
      if (!element.dataset.productId || !element.dataset.sectionId) return;
      element.setAttribute('data-kanpla-nudge', String(Date.now()));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nudge);
  } else {
    nudge();
  }

  window.addEventListener('load', nudge);
  document.addEventListener('shopify:section:load', nudge);
})();
